import React, { Fragment } from 'react';
import { CardBody, Card } from 'reactstrap';
import {
    Separator, Colxx
} from '../../../../../components/common/CustomBootstrap';

export default function Example({ url, height }) {
    return (
        <Card>
            <CardBody className="mt-0">
                <Card className="m-2">
                    <Colxx xxs="12 " className="p-3">
                            <div className="text-center">
                                <h6> Example </h6>
                                <Separator className="mb-3" />
                                <img
                                    src={url}
                                    alt="example"
                                    width="auto"
                                    style={{ height: height === undefined ? "" : height }}
                                    className="img-thumbnail"
                                />
                            </div>
                    </Colxx>
                </Card>
            </CardBody>
        </Card>

    );
}
